import { SmsBundleTierModal } from '@ctct/payflow-ui';

import type { AddOnsWidgetProps } from './useAddOnsWidget';

/**
 * Renders the mobile-only SMS bundle tier-selection modal. Opened by the order
 * summary "Edit add-on" button on mobile via the `smsBundleTierEditClicked`
 * event. Independent of the inline configurator dropdown so it can be mounted
 * on checkout pages where the configurator is hidden (e.g. mWeb checkout).
 */
export const SmsBundleTierModalWidget = ({ status, data, hooks, handlers, externalHooks }: AddOnsWidgetProps) => {
  const modalOpen = hooks.useSmsBundleTierModalOpen();
  const selectedTier = hooks.useSelectedSmsBundleTier();
  const prepay = externalHooks.usePrepay();

  if (status !== 'loaded' || !data.getIsSmsBundle()) {
    return null;
  }

  const rows = data.getSmsBundleTierModalRows(prepay);

  if (rows.length === 0) {
    return null;
  }

  const copies = data.getSmsBundleTierModalCopies();

  return (
    <SmsBundleTierModal
      open={modalOpen}
      onOpenChange={handlers.onSmsBundleTierModalOpenChange}
      title={copies.title}
      closeAriaLabel={copies.closeAriaLabel}
      rows={rows}
      selectedValue={selectedTier ?? null}
      onSelect={handlers.onSmsBundleTierModalSelect}
    />
  );
};
